import api from './api';
import { CPB_URL } from './servers';

export const fetchTemplates = () => api.post(`${CPB_URL}/descargas/getPlantillas`);

export const fetchParametersTemplate = (data) =>
  api.post(`${CPB_URL}/descargas/getParametrosPlantilla`, data);

export const saveParametersTemplate = (data) =>
  api.post(`${CPB_URL}/descargas/sincronizarPlantilla`, data);
